import {
  enviarReporteDuck,
  produccionNotasGetDuck,
  produccionSelectorGetDuck,
  reportesEnviadosGetDuck,
} from './duck';

const produccionReducers = {
  produccionSelectorGet: produccionSelectorGetDuck.reducer,
  produccionNotasGet: produccionNotasGetDuck.reducer,
  reportesEnviadosGet: reportesEnviadosGetDuck.reducer,
  enviarReporte: enviarReporteDuck.reducer,
};

export {produccionReducers};
